import React from "react"

// next
import { useRouter } from "next/router"

// antd
import {
  Row,
  Col,
  Tooltip,
  Tag,
  Typography,
  Button,
  Space,
  List,
  Affix,
} from "antd"
import {
  ShoppingCartOutlined,
  InfoCircleOutlined,
  CarFilled,
  EuroOutlined,
  ClockCircleFilled,
} from "@ant-design/icons"

// utils
import dayjs from "utils/dates"

// styles
import styled from "@emotion/styled"

// compoennts
import Speisekarte from "components/Menu"
import Zusatzstoffe from "components/Zusatzstoffe"
import OrderDrawer from "components/OrderDrawer"

// config
import config from "config"

// store
import { useFunnel } from "store/funnel"
import { useOrders } from "store/orders"
import { useTranslation } from "react-i18next"

// utils
import { formatAsCurrency } from "utils/currency"

const Page = styled.div`
  .detail-bar {
    padding: 16px 0;
    transition: background-color 0.3s;
  }

  .affixed {
    background: rgba(239, 239, 239, 1);
    background: white;
    margin-left: -26px !important;
    margin-right: -26px !important;
    padding-left: 16px;
    padding-right: 16px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom: 1px solid black;
  }
`

const TabOnlineOrder = () => {
  const router = useRouter()
  const orders = useOrders()
  const funnel = useFunnel()
  const { t } = useTranslation()
  const [showCart, setShowCart] = React.useState(false)
  const [affixed, setAffixed] = React.useState(false)

  const tableMode = !!router.query.table && !!config.eat_in

  return (
    <Page>
      <OrderDrawer
        open={showCart}
        onClose={(orderId) => {
          setShowCart(false)
          funnel.add("close_cart")

          if (orderId) {
            router.push(`/order?id=${orderId}`)
          }
        }}
      />

      <Affix onChange={(affixed) => setAffixed(affixed)}>
        <Row
          justify="space-between"
          gutter={16}
          align="top"
          className={affixed ? "detail-bar affixed" : "detail-bar"}
        >
          <Col xl={20} lg={18} md={16} sm={12} xs={12}>
            <Typography.Title
              level={affixed ? 5 : 3}
              style={{
                // color: config.textColor,
                fontStyle: "italic",
                margin: 0,
              }}
            >
              {tableMode
                ? `${t("table")} ${router.query.table}`
                : t("online_order")}
            </Typography.Title>

            {!affixed ? (
              <div
                style={{
                  marginTop: 8,
                }}
              >
                {config.delivery && !tableMode && (
                  <div>
                    {config.min_delivery_amount && (
                      <Tooltip
                        color="white"
                        title={
                          <Typography.Text size="small">
                            {config.min_delivery_amount_distance
                              ? t("min_delivery_tooltip", {
                                  distance: config.min_delivery_amount_distance,
                                })
                              : t("min_delivery_tooltip_no_distance")}
                          </Typography.Text>
                        }
                      >
                        <Tag icon={<ShoppingCartOutlined />}>
                          min. {config.min_delivery_amount} EUR
                        </Tag>
                      </Tooltip>
                    )}

                    {config.min_delivery_amount_by_zip &&
                      config.min_delivery_amount_by_zip.length > 0 && (
                        <Tooltip
                          color="white"
                          title={
                            <List
                              size="small"
                              dataSource={config.min_delivery_amount_by_zip}
                              renderItem={(item) => (
                                <Space>
                                  {item.zip && (
                                    <Typography.Text
                                      strong
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {item.zip}
                                    </Typography.Text>
                                  )}
                                  <Typography.Text>
                                    {item.label}
                                  </Typography.Text>
                                  <Typography.Text italic>
                                    {item.min_delivery_amount} EUR
                                  </Typography.Text>
                                </Space>
                              )}
                            />
                          }
                        >
                          <Tag icon={<InfoCircleOutlined />}>
                            {`min. ${
                              config.min_delivery_amount_by_zip[0]
                                .min_delivery_amount
                            } - ${
                              config.min_delivery_amount_by_zip[
                                config.min_delivery_amount_by_zip.length - 1
                              ].min_delivery_amount
                            } EUR / ${t("zip")}`}
                          </Tag>
                        </Tooltip>
                      )}

                    {config.max_delivery_location_in_km && (
                      <Tooltip
                        color="white"
                        title={
                          <Typography.Text size="small">
                            {t("max_delivery_tooltip")}
                          </Typography.Text>
                        }
                      >
                        <Tag icon={<CarFilled />}>
                          max. {config.max_delivery_location_in_km}km
                        </Tag>
                      </Tooltip>
                    )}
                    {config.cost_by_distance && (
                      <Tooltip
                        color="white"
                        title={
                          <div>
                            <Typography.Paragraph size="small">
                              {t("cost_by_distance_tooltip")}

                              {Object.entries(config.cost_by_distance).map(
                                (item) => (
                                  <Typography.Paragraph
                                    style={{ margin: 0 }}
                                    size="small"
                                    key={item[0]}
                                  >
                                    {`< ${item[0]}km: +${item[1]} EUR`}
                                  </Typography.Paragraph>
                                )
                              )}
                            </Typography.Paragraph>
                          </div>
                        }
                      >
                        <Tag icon={<CarFilled />}>
                          +{Object.entries(config.cost_by_distance)[0][1]} EUR
                        </Tag>
                      </Tooltip>
                    )}
                    {config.pick_up_discount && (
                      <Tooltip
                        color="white"
                        title={
                          <Typography.Text size="small">
                            {t("pickup_discount_tooltip")}
                          </Typography.Text>
                        }
                      >
                        <Tag icon={<EuroOutlined />}>
                          {config.pick_up_discount}% Abholrabatt
                        </Tag>
                      </Tooltip>
                    )}
                    {config.delivary_end_min &&
                      config.hours[new Date().getDay()] && (
                        <Tooltip
                          color="white"
                          title={
                            <Typography.Text size="small">
                              {t("delivery_end_tooltip", {
                                minutes: config.delivary_end_min,
                              })}
                            </Typography.Text>
                          }
                        >
                          <Tag icon={<ClockCircleFilled />}>
                            <span>
                              {dayjs(
                                config.hours[new Date().getDay()][
                                  config.hours[new Date().getDay()].length - 1
                                ].end_time
                              )
                                .add(-config.delivary_end_min, "minute")
                                .format("HH:mm")}
                            </span>
                          </Tag>
                        </Tooltip>
                      )}
                  </div>
                )}
              </div>
            ) : null}
          </Col>
          <Col xl={4} lg={6} md={8} sm={12} xs={12} align="end" justify="end">
            <Button
              data-testid="order-button"
              data-testvalue={orders.order.total}
              type="primary"
              onClick={() => {
                setShowCart(true)
                funnel.add("view_cart")
              }}
              icon={<ShoppingCartOutlined />}
            >
              {t("order_btn")} {`(${formatAsCurrency(orders.order.total)})`}
            </Button>
          </Col>
        </Row>
      </Affix>

      <Speisekarte
        onAdd={(item, amount) => {
          for (let i = 0; i < amount; i++) {
            orders.order.add(item)
          }
          funnel.add("add_to_cart")
        }}
      />

      <Zusatzstoffe />
    </Page>
  )
}

export default TabOnlineOrder
